import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { TagService } from '@app/modules/tag/services/tag.service';
import { catchError, map, tap } from 'rxjs/operators';
import * as TagApiActions from '@app/modules/tag/actions/tag-api.actions';
import { Store } from '@ngrx/store';
import { State } from '@app/reducers';

export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const tagService = inject(TagService);
    const router = inject(Router);
    const store = inject(Store<State>);

    return tagService.get(route.params['id']).pipe(
        map(tag => TagApiActions.GetSuccess(tag)),
        tap((action: any) => store.dispatch(action)),
        map(tag => !!tag),
        catchError(() => {
            return router.navigate(['/not-found']);
        })
    );
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);
